import PropTypes from "prop-types";
import { getNotificationAppointmentTarget } from "pages/calendar/notificationAppointmentTarget";
import React, { useState, useEffect } from 'react';
import 'moment';
import config from "../../../../../config";
import { useLocation, useNavigate } from 'react-router';
import { NotificationListApi, NotificationToCalendar, NotificationUpdateApi, UpcomingNotifyDetailDrawer } from 'store/slices/notificationSlice';
import { useSelector, useDispatch } from 'react-redux';
import MoonLoader from "react-spinners/MoonLoader";
import { AddAppointmentForm, AppointmentDetailModal, RescheduleAppointmentForm, ShowLoadingSpinner, appointmentDetailApi } from 'store/slices/appointmentSlice';
import 'store/slices/calendarSlice';
import { AddBusytimeForm, EditBusytimeForm } from 'store/slices/busytimeSlice';
import 'store/slices/staffSlice';
import 'store/slices/salonSlice';
import { sweatalert } from 'component/Sweatalert2';
import customToast from 'component/Toastr';
import { usercheckAccess } from 'helpers/Functions';
import { useTranslation } from 'react-i18next';
import { canOpenNotificationAppointment, notificationRows, toNotificationViewModel } from '../notificationViewModel';
import { formatNotificationAge, notificationReceivedAt } from '../notificationDate';
import NotificationSchedule from '../NotificationSchedule';

const BookingNotificationList = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [loader, setLoader] = useState({});
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 60000);
    return () => clearInterval(timer);
  }, []);
  const views = props && props.view;
  const viewData = notificationRows(views);
  const objectData = viewData && viewData.length > 0 ? viewData.filter((item) => item.type === "online_booking") : [];
  useSelector(state => state.notification.isUpcomingNotifyDetailTab);
  useSelector(state => state.client.isClientDetailTab);
  const auth = useSelector((state) => state.auth);
  const currentUser = auth.user;
  const role_id = currentUser && currentUser.role_id;
  const single_staff_access = usercheckAccess("calendar_view", currentUser);
  const singleStaffAccess = role_id === 8 ? '' : (single_staff_access && currentUser && currentUser.is_owner === 0) ? 1 : '';

  return (
    <div>
      {objectData && objectData.length > 0 ? (
        <>
          {Object.keys(objectData).map((item, index) => {
            const notification = toNotificationViewModel(objectData[item]);
            const canOpenAppointment = canOpenNotificationAppointment(notification);
            const id = notification.actionId || "";
            const profilePhotoUrl = notification.client.profile_photo_url || "";
            const first_name = notification.client.first_name || "";
            const last_name = notification.client.last_name || "";
            const iconUrl = "eye-round.png";
            const receivedAt = notificationReceivedAt(objectData[item]);
            const datedifference = formatNotificationAge(receivedAt, now);
            const service_name = notification.serviceName;
            const is_seen = objectData[item] && objectData[item].is_seen == 0 ? 0 : 1;
            const staff_first_name = notification.appointment.staff && notification.appointment.staff.first_name ? notification.appointment.staff.first_name : "";
            const staff_last_name = notification.appointment.staff && notification.appointment.staff.last_name ? notification.appointment.staff.last_name : "";
            void (objectData[item] && objectData[item].appointment && objectData[item].appointment.staff_id ? objectData[item].appointment.staff_id : "");
            let notification_appointment_id = notification.appointmentId;
            let notification_client_id = notification.clientId;
            let notification_showdate = getNotificationAppointmentTarget(objectData[item]).showdate;
            let notification_start_date = getNotificationAppointmentTarget(objectData[item]).showstartdate;
            let notification_end_date = getNotificationAppointmentTarget(objectData[item]).showenddate;

            return (
              <div className="box-image-cover notification-boxs w-100 mx-0 py-md-4 py-3 text-start" style={{ background: `${is_seen == 1 ? "#fff" : "#f9f6f4"}`,marginBottom:`${index === objectData.length - 1 ? "43px" : "0px"}`  }} key={index}>
                <div className="row align-items-center">
                  <div className="col-xxl-9 col-md-8 mb-md-0 mb-2">
                    <div className="d-flex align-items-center">
                      <div className="text-center">
                        {profilePhotoUrl ? (
                          <img src={profilePhotoUrl} alt="" className="rounded-circle wh-40 profile-image-obj mwh-40" />
                        ) : (
                          <div className="user-initial text-uppercase profile-image-height wh-40 mwh-40">{first_name && last_name && first_name.charAt(0) + "" + last_name.charAt(0)}</div>
                        )}
                      </div>
                      <div className="ps-3">
                        <div>
                          <h6 className='fw-semibold mb-0'>{`${first_name} ${last_name}`}</h6>
                        </div>
                        <div>
                          <p className='fw-semibold mb-0'>{`${service_name} with ${staff_first_name + " " + staff_last_name}`}</p>
                          <NotificationSchedule row={objectData[item]} />
                          {notification.invoiceNumber && <p className='mb-0'>Invoice #{notification.invoiceNumber}</p>}
                          <div>
                            <time className='color-wine' dateTime={receivedAt}>{datedifference}</time>
                          </div>
                            <p className={notification.event_type === "appointment_cancelled" ? "mb-0 text-danger" : "mb-0"}>{t(notification.appointmentEventLabel)}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-md-4 ps-md-0 d-flex justify-content-end align-items-center">
                    {canOpenAppointment ? (
                      <>
                        {iconUrl ? (
                          <span
                            onClick={async () => {
                              setLoader((prevLoader) => ({ ...prevLoader, [index]: true }));
                              dispatch(NotificationUpdateApi({ id, is_seen: 1 })).then((action) => {
                                if (action.meta.requestStatus === "fulfilled") {
                                  dispatch(NotificationListApi());
                                }
                              });
                              if (!notification.isAppointmentNotification) {
                                setLoader((prevLoader) => ({ ...prevLoader, [index]: false }));
                                customToast.error(t("This booking notification does not contain appointment details."));
                                return;
                              }
                              dispatch(NotificationToCalendar(objectData[item]));
                              if (location && location.pathname === "/calendar") {
                                try {
                                  dispatch(ShowLoadingSpinner(true));
                                  dispatch(AddAppointmentForm(""));
                                  dispatch(AddBusytimeForm(""));
                                  dispatch(EditBusytimeForm(""));
                                  dispatch(RescheduleAppointmentForm(""));
                                  dispatch(
                                    appointmentDetailApi({
                                      id: notification_appointment_id,
                                      client_id: notification_client_id,
                                      showdate: notification_showdate,
                                      showstartdate: notification_start_date,
                                      showenddate: notification_end_date,
                                      page_name: "calendar",
                                      singlestaffaccess: singleStaffAccess
                                    }),
                                  ).then((action) => {
                                    setLoader((prevLoader) => ({ ...prevLoader, [index]: false }));
                                    if (action.meta.requestStatus === "fulfilled" && action.payload && action.payload.id) {
                                      dispatch(AppointmentDetailModal(true));
                                      setTimeout(() => {
                                        dispatch(AppointmentDetailModal("open"));
                                      }, config.modalOpenTimeOut);
                                    } else if (action.meta.requestStatus === "fulfilled") {
                                      dispatch(ShowLoadingSpinner(false));
                                      customToast.error(t("Unable to load the appointment details."));
                                    } else if (action.meta.requestStatus === "rejected") {
                                      dispatch(ShowLoadingSpinner(false));
                                      if (action.payload && action.payload.status === 422) {
                                        const error = action.payload;
                                        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
                                        sweatalert({
                                          title: message.errors.document[0],
                                          text: message.errors.document,
                                          icon: "error",
                                        });
                                      }
                                    }
                                  })
                                } catch (error) {
                                  console.log(error);
                                  customToast.error('Sorry there was a problem, please refresh your browser');
                                  setLoader((prevLoader) => ({ ...prevLoader, [index]: false })); // Set loader back to false after the action is completed
                                  dispatch(ShowLoadingSpinner(false));
                                  dispatch(UpcomingNotifyDetailDrawer(""));
                                }
                              } else {
                                setTimeout(() => {
                                  setLoader((prevLoader) => ({ ...prevLoader, [index]: false }));
                                  navigate(config.basePath + "/calendar");
                                  dispatch(UpcomingNotifyDetailDrawer(""));
                                }, 1000);
                              }
                              }}>
                            {loader[index] ? (
                              <MoonLoader color="#8c1c4d" size="22px" />
                            ) : (
                              <img src={config.imagepath + iconUrl} alt="" className="rounded-circle wh-25 profile-image-obj" />
                            )}
                          </span>
                        ) : ""}
                      </>
                    ) : null}
                  </div>
                </div>
              </div>
            )
          })}
        </>
      ) : (
        <div className="complete-box text-center d-flex flex-column justify-content-center mt-5">
          <div className="complete-box-wrp text-center">
            {/* <img src={config.imagepath + "bellnotifications.png"} alt="" className="mb-md-4 mb-3" /> */}
            <img src={config.imagepath + "notification-bell.png"} alt="" className="mb-md-4 mb-3" />
            <h5 className="mb-2 fw-semibold" style={{ color: 'rgb(151,136,136)' }}>{t("No notification found")}</h5>
          </div>
        </div>
      )}
    </div>
  )
}

BookingNotificationList.propTypes = {
  view: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default BookingNotificationList;
